import i18n from 'i18n-js'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import nl from './nl.json'
import { setI18nToReload } from './redux/Actions'

i18n.defaultLocale = 'es'
i18n.locale = 'es'
i18n.fallbacks = true
i18n.translations = { es, en, fr, nl }
i18n.currentLocale()

export function setI18nLang(lang, dispatch) {
  i18n.locale = lang
  i18n.currentLocale()
  dispatch(setI18nToReload(lang))
}

export default i18n
